module.exports = __webpack_public_path__ + "img/thumbnail_SaltwaterCrocodile_j_albino.2037bd1c.png";